<script setup lang="ts">
import ButtonClose from '@/components/button/ButtonClose.vue'
import {
    alertMessageConfirmDeleteAddressHappy,
    alertMessageConfirmDeleteAddressHappyEmpty
} from '@/happyTheme/event/dashboard/address/alertMessageConfirmDeleteAddressHappy'
import {
    alertMessageDeleteAddressHappy,
    alertMessageDeleteAddressHappyEmpty
} from '@/happyTheme/event/dashboard/address/alertMessageDeleteAddressHappy'
import { TimeOutClass } from '@/happyTheme/services/timeout/TimeOutClass'
import { AddressService } from '@/services/AddressService'
import { ref, watch } from 'vue'

const isVisible = ref(false)
const responseIsVisible = ref(false)

function toggleAlertDeleteAddress() {
    const timeOutClear = TimeOutClass.getInstance()
    timeOutClear.clearIdTimeout()

    isVisible.value = false
    alertMessageConfirmDeleteAddressHappy.value =
        alertMessageConfirmDeleteAddressHappyEmpty
    const idTimeOut = setTimeout(() => {
        alertMessageDeleteAddressHappy.value = alertMessageDeleteAddressHappyEmpty
    }, 300)
    const timeOut = TimeOutClass.getInstance()
    timeOut.setIdTimeout(idTimeOut)
}

async function deleteAddress() {
    const addressId = alertMessageDeleteAddressHappy.value.city.address_id
    if (!addressId) return

    const addressService = new AddressService()
    const res = await addressService.deleteAddress(addressId)

    if (res.class === 'success') {
        const idTimeOut = setTimeout(() => {
            isVisible.value = false
            setTimeout(() => {
                alertMessageDeleteAddressHappy.value = alertMessageDeleteAddressHappyEmpty
            }, 200)
        }, 3100)
        const timeOut = TimeOutClass.getInstance()
        timeOut.setIdTimeout(idTimeOut)
    }
}

watch(
    () => alertMessageDeleteAddressHappy.value,
    (newValue) => {
        if (newValue && newValue.message) {
            setTimeout(() => {
                isVisible.value = true
            }, 10)
        } else {
            isVisible.value = false
        }
    },
    { immediate: true }
)

watch(
    () => alertMessageConfirmDeleteAddressHappy.value,
    (newValue) => {
        if (newValue && newValue.message) {
            // setTimeout(() => {
            responseIsVisible.value = true
            // }, 2)
            setTimeout(() => {
                responseIsVisible.value = false
            }, 3000)
        } else {
            responseIsVisible.value = false
        }
    },
    { immediate: true }
)
</script>

<template>
    <section class="section-alert-delete-address-happy">
        <section
            class="section-alert-delete-address-overlay-happy"
            @click="toggleAlertDeleteAddress"
        ></section>

        <section
            class="section-alert-delete-address-content-happy"
            :class="{
                ['translate-y-0 opacity-100 ' + alertMessageDeleteAddressHappy.class]:
                    isVisible,
                '-translate-y-20 opacity-0': !isVisible
            }"
        >
            <div
                class="div-alert-message-content-address-happy"
                :class="`div-content-message-content-address-happy-${alertMessageDeleteAddressHappy.class}`"
            >
                <ButtonClose
                    :function="toggleAlertDeleteAddress"
                    :hover-color="
                        alertMessageDeleteAddressHappy.class === 'success'
                            ? 'success-happy'
                            : 'error-happy'
                    "
                />
            </div>
            <div class="div-alert-message-second-content-address-happy">
                <h4 class="font-semibold">{{ alertMessageDeleteAddressHappy.title }}</h4>

                <div class="div-content-message-content-address-happy">
                    <p
                        class="p-alert-message-content-address-happy"
                        :class="`p-content-message-content-address-happy-${alertMessageDeleteAddressHappy.class}`"
                    >
                        {{ alertMessageDeleteAddressHappy.message }}
                    </p>
                    <div v-if="alertMessageDeleteAddressHappy.city">
                        <p
                            class="text-sm font-semibold"
                            v-if="alertMessageDeleteAddressHappy.city.name_city"
                        >
                            Ville : {{ alertMessageDeleteAddressHappy.city.name_city }}
                        </p>
                        <p
                            v-if="alertMessageDeleteAddressHappy.city.address_1"
                            class="text-sm"
                        >
                            Adresse :
                            {{ alertMessageDeleteAddressHappy.city.address_1 }}
                        </p>
                    </div>
                </div>
            </div>

            <div
                v-show="alertMessageDeleteAddressHappy.message"
                class="div-alert-response-main-delete-address-happy"
                :class="{
                    'translate-y-0 opacity-100': responseIsVisible,
                    ' -translate-y-4 opacity-0': !responseIsVisible
                }"
            >
                <div class="div-alert-response-delete-address-happy">
                    <p>{{ alertMessageConfirmDeleteAddressHappy.message }}</p>
                </div>
            </div>

            <div class="div-alert-message-button-content-address-happy">
                <button
                    class="btn-alert-cancel-address-happy"
                    @click="toggleAlertDeleteAddress"
                >
                    Annuler
                </button>

                <button
                    class="btn-alert-delete-address-happy"
                    :class="`btn-alert-delete-address-${alertMessageDeleteAddressHappy.class}`"
                    @click="deleteAddress()"
                >
                    Confirmer
                </button>
            </div>
        </section>
    </section>
</template>

<style scoped>
.section-alert-delete-address-happy {
    @apply fixed flex top-0 left-0 w-full h-full z-30 justify-center;
}

.section-alert-delete-address-overlay-happy {
    @apply w-full h-full z-30 bg-transparent;
}
.section-alert-delete-address-content-happy {
    @apply z-40 absolute w-[19rem] flex flex-col justify-center mt-44 rounded-md transition-all duration-300 ease-out h-auto;
}

.div-alert-message-content-address-happy {
    @apply w-full h-full rounded-t-md flex justify-end p-3;
}
.div-content-message-content-address-happy-success {
    @apply bg-green-light-happy;
}
.div-content-message-content-address-happy-error {
    @apply bg-header-red-happy;
}
.div-alert-message-second-content-address-happy {
    @apply w-full h-full flex flex-col rounded-b-md  py-3 gap-3 text-center;
}

.div-content-message-content-address-happy {
    @apply w-full h-full flex flex-col rounded-b-md px-3 gap-2;
}
.success {
    @apply bg-green-happy text-text-dark-happy-light;
}
.error {
    @apply bg-border-red-happy-light  text-bg-happy-light;
}

.div-alert-response-main-delete-address-happy {
    @apply px-2 py-1 transition-all duration-150 ease-out;
}

.div-alert-response-delete-address-happy {
    @apply w-full  px-1 py-1 rounded-md text-center bg-border-gray-happy-light text-text-dark-happy-light font-semibold text-sm;
}

.div-alert-message-button-content-address-happy {
    @apply w-full flex justify-end gap-2 py-2 px-2;
}

.btn-alert-cancel-address-happy {
    @apply px-4 py-1 rounded-md bg-bg-happy-light text-text-dark-happy-light shadow-sm shadow-text-dark-happy-light;
}
.btn-alert-cancel-address-happy:active {
    @apply px-4 py-1 rounded-md bg-border-gray-happy-light  text-bg-happy-light shadow-sm shadow-text-dark-happy-light;
}

.btn-alert-delete-address-happy {
    @apply px-4 py-1 rounded-md bg-mouse-enter-red-happy-light shadow-sm shadow-text-dark-happy-light text-bg-happy-light;
}
.btn-alert-delete-address-happy:active {
    @apply bg-header-red-happy shadow-sm shadow-text-dark-happy-light;
}
</style>
